<template>
  <div class="box" :style="{'height': windowHeight+'px'}">
    <div class="mask-style" v-if="activity">
      <div class="active-max-box" style="text-align: center;">
        <div style="position: relative;color: #fff;">
          <img src="static/img/rulebg1.png" alt />
          <p class="rule-content" style="position: absolute;padding: 105px 48px 0px">
            1. 活动有效期：2020-04-01— 2020-04-30。
            <br />2. 代金券可在有效期内使用；有效期内每张代金券仅限使用一次。
            <br />3. 本代金券在麦德通平台内，可抵扣所有类型订单金额。
            <br />4. 本代金券可叠加使用，超出订单金额部分不予返还。
            <br />5. 如发现恶意盗刷代金券等行为，麦德通有权作废该行为涉及的代金券，并取消订单，甚至关闭商户账号。
          </p>
        </div>
        <img
          class="ruleclose"
          @click="activityRules"
          style="width: 50px;margin: 40px auto;"
          src="static/img/ruleclose.png"
          alt
        />
      </div>
    </div>
    <div>
      <div
        style="margin:0 auto;position:absolute;left:50%;transform:translateX(-50%);width:100%;z-index: -1;"
      >
        <img src="static/img/land4bg1.png" alt />
      </div>
      <div v-show="liderValidation" :style="{'height': windowHeight+'px'}" class="maskStyle">
          <slider :clickBtnNum='1' :slider='duoge1' :phoneValue="phoneValue" @sliderSuccess="sliderSuccess" ref="slider"></slider>
      </div>
      <div style="margin:0 auto;">
        <div class="active-button" @click="activityRules">
          <img src="static/img/land4button-bg1.png" alt />
        </div>

        <div style="box-sizing: border-box;padding: 415px 20px 0;">
          <div style="box-sizing:border-box;">
            <div class="input-box">
              <img src="static/img/land4phone.png" alt />
              <input
                type="text"
                class="phone phone1"
                id="phone1"
                name
                v-model="phoneValue"
                placeholder="手机号码"
                maxlength="11"
              />
            </div>
            <div class="input-box" style="padding: 0px 40px 0px 0px;border: 0 none;">
              <div
                style="width: 100%;height: 100%;overflow: hidden;border-bottom: 1px solid #fff;padding-left: 40px;box-sizing: border-box;"
              >
                <img src="static/img/land4-code-bg.png" alt />
                <div style="width: 100%;height: 100%;overflow: hidden;position: relative;">
                  <input
                    type="text"
                    class="code-msg code-msg1"
                    style="left: 0;"
                    name
                    id="smscode"
                    v-model="codeValue"
                    placeholder="短信验证码"
                    maxlength="6"
                  />
                </div>
              </div>
              <button v-if="!codeNumber" class="code-button code-button1" @click="sendCode">
                <img src="static/img/land4button-code-bg.png" alt />
              </button>
              <button v-if="codeNumber" class="code-button code-button1 codeNumberStyle">{{time}}</button>
            </div>
            <div class="input-box">
              <img src="static/img/land4pwd.png" alt />
              <input
                type="password"
                class="pwd-val pwd-val1"
                name
                id="pwd"
                v-model="passWordValue"
                placeholder="密码,6-18位字母数字组合"
                maxlength="20"
              />
            </div>
          </div>
          <div class="button-box" @click="registered" style="margin-top:14px">
            <div class="button-bg button-bg1" style="padding:0px ;box-sizing:border-box;">
              <img src="static/img/land4button-bg2.png" alt />
              <!-- <span>立即注册</span> -->
            </div>
          </div>
          <div style="padding:10px 0px 0px;box-sizing:border-box;position:relative">
            <span style="font-size: 12px;text-align: left;position:static;float: left;">
              <img
                src="static/img/land4argee.png"
                v-if="agree"
                @click="agreeClick"
                class="agreement agreementSuccess"
                style="width: 14px;vertical-align: middle;float: left;margin-right:10px"
                alt
              />
              <img
                src="static/img/land4disargee.png"
                v-if="!agree"
                @click="agreeClick"
                class="agreement"
                style="width: 14px;vertical-align: middle;float: left;margin-right:10px"
                alt
              /> 已同意
              <router-link to="./agreezc" style="color: #E34D39;">《麦德通用户协议》</router-link>和
              <router-link to="./agreeys" style="color: #E34D39;">《隐私及信息保护政策》</router-link>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="modal-box">
      <p class="title">欢迎加入麦德通</p>
      <p>您可以在这里完成快速注册</p>
      <div>
        <div class="input-box">
          <input
            type="text"
            class="phone"
            name
            v-model="phoneValue"
            placeholder="手机号码"
            maxlength="11"
          />
        </div>
        <div class="input-box" style="padding-right: 90px;">
          <input
            type="text"
            class="code-msg"
            v-model="codeValue"
            name
            id="smscode"
            placeholder="短信验证码"
            maxlength="6"
          />
          <button v-if="!codeNumber" @click="sendCode" class="code-button">{{senCodeButton}}</button>
          <button v-if="codeNumber" class="code-button codeNumberStyle">{{senCodeButton}}</button>
        </div>
        <div class="input-box">
          <input
            type="password"
            class="pwd-val"
            v-model="passWordValue"
            name
            id="pwd"
            placeholder="密码,6-18位字母数字组合"
            maxlength="20"
          />
        </div>
        <div class="input-box" style="padding: 0;border: 0 none;">
          <button class="modal-submit-button modal-submit">注册</button>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
// import dragVerify from "@/components/dragVerify.vue";
import slider from "@/components/slider";
import { sendCode,registered,channelNo } from "../api/land";
export default {
  name: "",
  data() {
    return {
      time: 60,
      duoge1: '#duoge1',
      senCodeButton: "发送验证码",
      codeNumber: false, //  倒计时展示
      agree: false, // 是否同意协议
      phoneValue: "", //绑定手机号
      codeValue: "", // 绑定验证码
      passWordValue: "", // 绑定密码
      codeShow: false, // 滑动验证码
      liderValidation: false, // 显示隐藏滑块验证
      interval: null, //  倒计时
      windowHeight: "", //可视区域高度
      activity: false, // 活动规则的显示隐藏
      aliCode: {},
      checkChannelFlag: true
    };
  },
  components: {
    slider
  },
  created() {
    document.title = 'VAT颠覆者！低至398元/2年，一站式VAT自主申报系统震撼上线！'
    this.windowHeight = document.documentElement.clientHeight;
    if (localStorage.getItem("time") && localStorage.getItem("time") > 0) {
      this.time = localStorage.getItem("time");
      this.codeTime();
    }

    let locationHref = window.location.href;
      if (locationHref.indexOf("?") > -1) {
        locationHref = decodeURI(locationHref);
        let param = "";
        if (locationHref.indexOf("&") > -1) {
          let params = locationHref.substring(
            locationHref.indexOf("?") + 1,
            locationHref.indexOf("&")
          );
          param = params.split("=")[1];
        } else {
          param = locationHref
            .substring(locationHref.indexOf("?") + 1)
            .split("=")[1];
        }
        this.aliCode.channelCode = param;
      }
      if (this.aliCode.channelCode) {
        this.channel()
      }
  },
  methods: {
    /**
     * @description 检验channelNo
     */
    channel() {
      channelNo({channelId: this.aliCode.channelCode}).then(res => {
        if(res.code ==0) {
          if  (!(res.rows.length > 0)) {
            this.$message.error(`该注册码(${this.aliCode.channelCode})有误，请联系您的客服经理`)
            this.checkChannelFlag = false
          }
        }
      }).catch(error => {
        this.$message.err('请求失败，请刷新页面后再试试')
      })
    },
    /**
     * @description 打开/关闭活动规则
     */
    activityRules() {
      this.activity = !this.activity;
    },
    /**
     * @description 是否同意协议
     */
    agreeClick() {
      this.agree = !this.agree;
    },
    /**
     *@description 滑块验证通过
     */
    sliderSuccess(e) {
      if (e !== "error") {
        this.aliCode = e;
        let land5 = new Date().getTime();
        localStorage.setItem("land5", land5);
        this.codeTime();
      }
      setTimeout(() => {
        this.liderValidation = false;
      }, 500);
    },
    
    /**
     * @description 点击发送验证码
     */
    sendCode() {
      if (this.phoneValue == "") {
        this.$message.warn("请输入手机号");
        return;
      }
      if (!/^[1][0-9]{10}$/.test(this.phoneValue)) {
        this.$message.warn("请输入正确的手机号");
        return;
      }
      this.liderValidation = true;
      if (this.liderValidation) {
        this.$refs.slider.getScroll();
      }
    },

    /**
     * @description 立即注册
     */
    registered() {
      // 校验手机号为空
      if (this.phoneValue === "") {
        this.$message.warn("请输入手机号");
        return;
      }
      // 校验 手机号格式
      if (!/^[1][0-9]{10}$/.test(this.phoneValue)) {
        this.$message.warn("请输入正确的手机号");
        return;
      }
      // 校验验证码为空
      if (this.codeValue === "") {
        this.$message.warn("请输入验证码");
        return;
      }
      // 校验密码为空
      if (this.passWordValue === "") {
        this.$message.warn("请输入密码");
        return;
      }
      // 校验密码格式错误
      if (
        !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,18}$/.test(this.passWordValue)
      ) {
        this.$message.warn("密码至少有一位数字和字母,6-18位字母数字组合");
        return;
      }
      // 校验协议
      if (!this.agree) {
        this.$message.warn(
          "请阅读并同意《麦德通用户协议》和《麦德通客服隐私》"
        );
        return;
      }
      if (!this.checkChannelFlag) {
        this.$message.error(`该注册码(${this.aliCode.channelCode})有误，请联系您的客服经理`)
        return;
      }
      this.aliCode.smscode = this.codeValue;
      this.aliCode.password = window.btoa(this.passWordValue);
      this.aliCode.phonenumber = this.phoneValue;
      
      registered(this.aliCode)
        .then(res => {
          if (res.code == 500) {
            this.$message.error(res.msg);
          } else if (res.code == 0) {
            this.$router.push({ path: "/success" });
          }
        })
        .catch(error => {
          console.log(error)
        });
    },
    /**
     * @description 倒计时封装
     */
    codeTime() {
      this.codeNumber = true;
      this.interval = setInterval(() => {
        this.senCodeButton = this.times + "s";
        localStorage.setItem("time", this.time);
        if (this.time <= 0) {
          this.senCodeButton = this.times + "s";
          this.codeNumber = false;
          window.clearInterval(this.interval);
          this.time = 60;
        }
        this.time--;
      }, 1000);
    }
  }
};
</script>
<style scoped>
@import "../assets/css/animate.min.css";
@import "../assets/css/index.css";
.box {
  overflow-x: hidden;
}
.mask-style {
  background: rgba(0, 0, 0, 0.6);
  z-index: 8;
  width: 100%;
  position: fixed;
  top: 0;
  padding-top: 80%;
  padding-left: 12%;
  height: 100%;
}
input {
  height: 70%;
  margin-top: 2.5px;
  background: #fca767 !important;
}
.maskStyle {
  background: rgba(0, 0, 0, 0.6);
  z-index: 8;
  width: 100%;
  position: fixed;
}
.mask-style-div{
  background:white;
  padding: 30px 15px 0px 15px;
  width: 85%;
  border-radius: 15px;
  margin: 80% 0 0 7.5%;
}
.maskStyle p{
  text-align: left;
  height: 35px;
  line-height: 35px;
  color: red;
  padding-left: 15px;
  margin: 8px 0;
}
.codeNumberStyle {
  background: #fe8a44 !important;
  font-size: 12px;
  padding: 5px;
  color: #2e34ae;
  border-radius: 2px;
  position: absolute;
  right: 10px;
  top: 6px !important;
  height: 60% !important;
  border-radius: 15px;
  outline: 0 none;
  color: white;
}
input {
  position: absolute;
  left: 40px;
  top: 0;
  padding-left: 20px;
  border-radius: 10px;
  line-height: 38px;
  box-sizing: border-box;
  background: transparent;
}
.input-box {
  height: 40px;
  border-color: #fff;
}
.input-box input {
  font-size: 15px;
  padding-left: 0;
  width: 80%;
  background: none !important;
}
.input-box img {
  top: 50%;
  transform: translateY(-50%);
}
.input-box .code-button {
  top: 24px;
  width: 80px;
  height: auto;
  left: auto;
  right: 0;
  background: transparent;
  border: 0 none;
  padding: 0;
}
.input-box .code-button img {
  width: 100%;
  height: 40px;
  left: 0;
}
.input-box .code-button span {
  position: absolute;
  left: 50%;
  top: -4.5px;
  color: #fff;
  transform: translateX(-50%);
}
.active-button {
  width: 100px;
  position: absolute;
  top: 4rem;
  left: 50%;
  transform: translateX(-50%);
}
.active-max-box {
  width: 90%;
  position: fixed;
  top: 3%;
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
}
.rule-content {
  position: absolute;
  box-sizing: border-box;
  top: 76px;
  font-size: 16px;
  line-height: 18px;
  text-align: left;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/ssss.vue